import PropTypes from 'prop-types';
import React from 'react';

import AttachView from './attach-view.jsx';
import RootView from './root-view.jsx';

class ModalGoogleDriveViewMain extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(['setRoot','attachFile']),
        data: PropTypes.array,
        rootFolder: PropTypes.string,
        attachments: PropTypes.array,

        onAttachFiles: PropTypes.func,
        onFolderClick: PropTypes.func,
        onDeleteClick: PropTypes.func,
        onAddFolder: PropTypes.func,
        onSelectRoot: PropTypes.func,
        onUpload: PropTypes.func,
        onRefresh: PropTypes.func,
    };

    static defaultProps = {
        type: 'attachFile'
    };

    onAddFolder = (title) => {
        const { onAddFolder, type } = this.props;
        if (onAddFolder) onAddFolder(title, type);
    };

    onUpload = (data) => {
        const { onUpload, type } = this.props;
        if (onUpload) onUpload(data, type);
    };

    render() {
        const { type, data, rootFolder, attachments, onAttachFiles, onFolderClick, onDeleteClick, onSelectRoot, onRefresh } = this.props;
        switch (type){
            case "attachFile": return <AttachView data={this.props.data}
                                                  rootFolder={rootFolder}
                                                  attachments={attachments}
                                                  onAttachFiles={onAttachFiles}
                                                  onFolderClick={onFolderClick}
                                                  onUpload={this.onUpload}
                                                  onDeleteClick={onDeleteClick}
                                                  onAddFolder={this.onAddFolder}
                                                  onRefresh={onRefresh}/>;
            case "setRoot": return <RootView data={this.props.data}
                                             onFolderClick={onFolderClick}
                                             onDeleteClick={onDeleteClick}
                                             onAddFolder={this.onAddFolder}
                                             onSelectRoot={onSelectRoot}
                                             onRefresh={onRefresh}/>;
        }
    }
}

module.exports = ModalGoogleDriveViewMain;